import React, { memo } from 'react';
import { Blok } from '../../interfaces/Blok.interface';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';

interface TablesBlokProps extends Blok {
    tables: Blok[];
}

interface TablesProps {
    blok: TablesBlokProps
}

const Tables: React.FC<TablesProps> = ({ blok }) => {
    const { tables } = blok; 

    return (
        <section {...storyblokEditable(blok)} className='not-prose w-full'>
            {tables.map((table: Blok) => <StoryblokComponent blok={table} key={table._uid} />)}
        </section>
    )
}

export default memo(Tables);